/**
 * Marquee Observer + Interactive Drag & Wheel
 * - Loop infinito senza mai fermarsi per il verticale
 * - Drag-to-scroll omnidirezionale: capisce se stai trascinando in giù o di lato
 * - Caroselli orizzontali interni scorrono da soli
 */
(function () {
  var SLOW_RATE = 0.15;
  var NORMAL_RATE = 1;
  var WHEEL_SPEED = 2;
  var DRAG_SPEED = 1.5;
  var INERTIA_DECAY = 0.92;
  var RESUME_DELAY = 2000;
  
  var CAROUSEL_INTERVAL = 3000; // 3 secondi per slide

  function getAnimation(track) {
    if (!track || !track.getAnimations) return null;
    var anims = track.getAnimations();
    return anims.length ? anims[0] : null;
  }

  function smoothRate(anim, targetRate) {
    if (!anim) return;
    var current = anim.playbackRate;
    var step = (targetRate - current) * 0.12;
    if (Math.abs(step) < 0.001) {
      anim.playbackRate = targetRate;
      return;
    }
    anim.playbackRate = current + step;
    requestAnimationFrame(function () { smoothRate(anim, targetRate); });
  }

  function getTrackOffset(track) {
    var style = window.getComputedStyle(track);
    var matrix = style.transform || style.webkitTransform;
    if (matrix && matrix !== 'none') {
      var values = matrix.match(/matrix.*\((.+)\)/);
      if (values) {
        var parts = values[1].split(', ');
        return parseFloat(parts[5]) || 0;
      }
    }
    return 0;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var marquees = document.querySelectorAll('.river-marquee');
    if (!marquees.length) return;

    marquees.forEach(function (marquee) {
      var track = marquee.querySelector('.river-marquee__track');
      if (!track) return;

      // ── Auto-scroll per i caroselli interni ────────────────────────
      var innerCarousels = marquee.querySelectorAll('.inner-carousel');
      innerCarousels.forEach(function(carousel) {
        carousel.dataset.isHovered = "false";
        carousel.addEventListener('mouseenter', function() { carousel.dataset.isHovered = "true"; });
        carousel.addEventListener('mouseleave', function() { carousel.dataset.isHovered = "false"; });

        setInterval(function() {
          // Se è hoverato o c'è un'interazione, non scorrere
          if (carousel.dataset.isHovered === "true" || window.globalIsDragging) return;
          
          var maxScroll = carousel.scrollWidth - carousel.clientWidth;
          var currentScroll = carousel.scrollLeft;
          var slideWidth = carousel.clientWidth;
          
          var nextScroll = currentScroll + slideWidth;
          if (nextScroll >= maxScroll + 10) { // +10 per tolleranza
            nextScroll = 0;
          }
          carousel.scrollTo({ left: nextScroll, behavior: 'smooth' });
        }, CAROUSEL_INTERVAL);
      });

      // ── Stato Drag Globale ─────────────────────────────────────────
      var isDragging = false;
      var isWheeling = false;
      var isManual = false;
      var dragDirection = null; // 'vertical' o 'horizontal'
      var activeCarousel = null; // Il carosello orizzontale su cui stiamo trascinando
      
      var startX = 0;
      var startY = 0;
      var lastX = 0;
      var lastY = 0;
      var velocity = 0;
      var animFrame = null;
      var resumeTimer = null;
      var manualOffset = 0;
      var hoveredCount = 0;

      // ── Hover sui singoli prodotti (Rallenta verticale) ────────────
      var items = marquee.querySelectorAll('.river-marquee__item');
      items.forEach(function (item) {
        item.addEventListener('mouseenter', function () {
          hoveredCount++;
          if (!isManual) smoothRate(getAnimation(track), SLOW_RATE);
        });
        item.addEventListener('mouseleave', function () {
          hoveredCount = Math.max(0, hoveredCount - 1);
          if (hoveredCount === 0 && !isManual) {
            smoothRate(getAnimation(track), NORMAL_RATE);
          }
        });
      });

      // ── Funzioni interazione ───────────────────────────────────────
      function startManualControl() {
        if (isManual) return;
        isManual = true;
        clearTimeout(resumeTimer);
        if (animFrame) cancelAnimationFrame(animFrame);

        manualOffset = getTrackOffset(track);
        var anim = getAnimation(track);
        if (anim) anim.pause();

        marquee.classList.add('is-dragging');
        track.style.animation = 'none';
        track.style.transform = 'translateY(' + manualOffset + 'px)';
      }

      function applyManualScroll(deltaY) {
        manualOffset += deltaY;
        var trackHeight = track.scrollHeight / 2;
        if (trackHeight > 0) {
          while (manualOffset > 0) manualOffset -= trackHeight;
          while (manualOffset < -trackHeight) manualOffset += trackHeight;
        }
        track.style.transform = 'translateY(' + manualOffset + 'px)';
      }

      function scheduleResume() {
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () {
          isManual = false;
          marquee.classList.remove('is-dragging');
          track.style.animation = '';
          track.style.transform = '';
          var anim = getAnimation(track);
          if (anim) {
            anim.play();
            smoothRate(anim, NORMAL_RATE);
          }
        }, RESUME_DELAY);
      }

      function endWithInertia() {
        window.globalIsDragging = false;
        if (dragDirection === 'horizontal' && activeCarousel) {
          // Snap gestito dal CSS
          scheduleResume();
          return;
        }

        if (Math.abs(velocity) > 1) {
          animFrame = requestAnimationFrame(function inertiaStep() {
            velocity *= INERTIA_DECAY;
            if (Math.abs(velocity) < 0.5) {
              scheduleResume();
              return;
            }
            applyManualScroll(velocity * DRAG_SPEED);
            animFrame = requestAnimationFrame(inertiaStep);
          });
        } else {
          scheduleResume();
        }
      }

      // ── Mouse/Touch Handlers ───────────────────────────────────────
      function pointerDown(e, x, y) {
        isDragging = true;
        window.globalIsDragging = true;
        dragDirection = null; // Decideremo al primo movimento
        startX = x;
        startY = y;
        lastX = x;
        lastY = y;
        velocity = 0;
        activeCarousel = e.target.closest('.inner-carousel');
      }

      function pointerMove(e, x, y) {
        if (!isDragging) return;

        var deltaX = x - lastX;
        var deltaY = y - lastY;

        // Se non abbiamo ancora deciso la direzione (soglia di 3px)
        if (!dragDirection) {
          if (Math.abs(x - startX) > 3 || Math.abs(y - startY) > 3) {
            if (activeCarousel && Math.abs(x - startX) > Math.abs(y - startY)) {
              dragDirection = 'horizontal';
            } else {
              dragDirection = 'vertical';
              startManualControl();
              e.preventDefault(); // Previeni scroll di default per il drag verticale
            }
          } else {
            return; // Aspettiamo di muoverci abbastanza
          }
        }

        // Ora agiamo in base alla direzione
        if (dragDirection === 'vertical') {
          velocity = deltaY;
          applyManualScroll(deltaY * DRAG_SPEED);
        } else if (dragDirection === 'horizontal') {
          // Emuliamo il drag orizzontale
          activeCarousel.scrollBy({ left: -deltaX * DRAG_SPEED });
        }

        lastX = x;
        lastY = y;
      }

      function pointerUp() {
        if (!isDragging) return;
        isDragging = false;
        endWithInertia();
      }

      marquee.addEventListener('mousedown', function (e) { pointerDown(e, e.clientX, e.clientY); });
      window.addEventListener('mousemove', function (e) { pointerMove(e, e.clientX, e.clientY); });
      window.addEventListener('mouseup', pointerUp);

      marquee.addEventListener('touchstart', function (e) { pointerDown(e, e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
      marquee.addEventListener('touchmove', function (e) { pointerMove(e, e.touches[0].clientX, e.touches[0].clientY); }, { passive: false });
      marquee.addEventListener('touchend', pointerUp);

      // ── Rotella del mouse (Verticale) ──────────────────────────────
      document.addEventListener('wheel', function (e) {
        var rect = marquee.getBoundingClientRect();
        var isVisible = rect.top < window.innerHeight && rect.bottom > 0;
        if (!isVisible) return;

        e.preventDefault();
        startManualControl();
        isWheeling = true;

        applyManualScroll(-e.deltaY * WHEEL_SPEED);

        clearTimeout(marquee._wheelTimeout);
        marquee._wheelTimeout = setTimeout(function () {
          isWheeling = false;
          scheduleResume();
        }, 600);
      }, { passive: false, capture: true });

    });
  });
})();
